import { get } from 'lodash';
import { mapActions, mapState } from 'vuex';
import withdrawConfirm from '@/components/wallet/withdraw-confirm/withdraw-confirm.vue';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import availableBalance from '@/components/wallet/available-balance/available-balance.vue';
import notificationIcon from '@/components/notification-icon/notification-icon.vue';
import { formMixin, validators } from '@/components/forms/mixin';
import documentUploadMixin from '@/mixins/documentUpload';
import contentLoaderMixin from '@/mixins/contentLoader';
import { roundDown } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/app-modals';

const DEFAULT_ACCOUNT_TYPE = '1';

export default {
  mixins: [
    contentLoaderMixin,
    documentUploadMixin,
    formMixin,
  ],
  components: {
    alertBox,
    availableBalance,
    notificationIcon,
    withdrawConfirm,
  },
  data() {
    return {
      newAccountMode: true,
      showConfirmation: false,
      error: '',
      fields: {
        amount: '',
        routingNumber: '',
        accountNumber: '',
        accountType: DEFAULT_ACCOUNT_TYPE,
      },
    };
  },
  validations() {
    if (this.newAccountMode) {
      return {
        fields: {
          accountNumber: validators.accountNumber,
          routingNumber: validators.routingNumber,
          amount: validators.withdrawalAmount(this.minWithdrawal, this.maxWithdrawal),
        },
      };
    }
    return {
      fields: {
        amount: validators.withdrawalAmount(this.minWithdrawal, this.maxWithdrawal),
      },
    };
  },
  created() {
    this.checkWithdrawAch();
  },
  computed: {
    ...mapState('wallet', ['ach']),
    accountTypes() {
      const results = [];
      if (!this.ach || !this.ach.bankAccountTypes) return results;

      Object.keys(this.ach.bankAccountTypes).forEach((index) => {
        const label = this.ach.bankAccountTypes[index];
        if (label !== 'Unknown') {
          results.push({ index, label });
        }
      });
      return results;
    },
    accountDetails() {
      const data = {
        routingNumber: this.fields.routingNumber,
        accountNumber: this.fields.accountNumber,
        accountType: this.fields.accountType,
        accountTypeLabel: this.accountTypeLabel,
      };
      if (!this.newAccountMode) {
        data.accountId = this.ach.accountAchDetailId;
        data.accountLastFourDigits = this.ach.achAccountNumberLastFour;
      }

      return data;
    },
    accountTypeLabel() {
      if (this.accountTypes.length === 0) return '';
      return this.accountTypes.filter(item => item.index === this.fields.accountType)[0].label;
    },
    availableBalance() {
      return (this.ach && this.ach.availableFundsString) ? this.ach.availableFundsString : '$0.00';
    },
    restrictedFunds() {
      return (this.ach && this.ach.restrictedFundsString) ? this.ach.restrictedFundsString : '';
    },
    minWithdrawal() {
      return (this.maxWithdrawal > 0) ? 1 : 0;
    },
    maxWithdrawal() {
      return this.ach ? roundDown(this.ach.availableFunds) : 0;
    },
    isAmountFieldDisabled() {
      return this.minWithdrawal < 1 || this.maxWithdrawal < 1;
    },
    errorMessage() {
      return this.error || this.ach.errorMessage;
    },
    hasErrorMessage() {
      return this.error || !!this.ach.errorMessage;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    ...mapActions('wallet', ['getWithdrawAch']),
    onSubmit() {
      this.showConfirmation = true;
    },
    onSuccess() {
      this.fields.amount = '';
      this.fields.routingNumber = '';
      this.fields.accountNumber = '';
      this.fields.accountType = DEFAULT_ACCOUNT_TYPE;
      this.showConfirmation = false;
      // this.$nextTick(() => { this.$v.$reset(); });
      this.checkWithdrawAch();
      this.$emit('success');
    },
    onEdit() {
      this.showConfirmation = false;
    },
    onChangeAccount() {
      this.newAccountMode = true;
    },
    showRoutingNumberModal() {
      this.setCurrentSmallPopup(MODALS.SMALL_ROUTING_NUMBER);
    },
    checkWithdrawAch() {
      this.getWithdrawAch()
        .then((data) => {
          this.checkDocumentUploadFlags(data);
          this.newAccountMode = !data.hasSavedAccount;
          this.isComponentReady = true;
        })
        .catch((error) => {
          this.isComponentReady = true;
          this.error = get(error, 'response.data.message', '');
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/ach/ach.js